<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  provide() {
    return {
      // reload: this.reload
    };
  },
  data() {
    return {
      // isRouterAlive: true
    };
  },
  methods: {
    // reload() {
    //   this.isRouterAlive = false
    //   this.$nextTick(() => {
    //     this.isRouterAlive = true
    //   })
    // }
  },
};
</script>

<style>
html,
body,
#app {
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
}
* {
  padding: 0;
  margin: 0;
}
.vdr {
  border: none !important;
  height: 100% !important;
}
.handle-mr {
  display: block !important;
  height: 100% !important;
  top: 5px !important;
  border: none !important;
  background-color: #081831 !important;
  width: 15px !important;
}
.el-scrollbar {
  width: 100%;
  height: 100%;
}
.el-scrollbar__wrap {
  overflow: scroll;
  height: 100%;
  overflow-x: auto !important;
  margin-bottom: 0 !important;
  margin-right: -17px !important;
}
.el-scrollbar__view {
  height: 100%;
}
.el-message-box {
  border: none !important;
  border-radius: 2px !important;
}
.el-message-box__header {
  background-color: #409eff;
  padding: 10px 15px !important;
}
.el-message-box__title {
  color: #fff !important;
}
.el-message-box__headerbtn {
  top: 10px !important;
  font-size: 18px !important;
}
.el-message-box__headerbtn .el-message-box__close {
  color: #fff !important;
}
.el-message-box__content {
  padding: 20px 15px !important;
}
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
.BMap_bubble_content {
  color: #333 !important;
}
.BMap_bubble_pop {
  border-radius: 5px !important;
}

.privateDialong .el-dialog {
  text-align: left;
}
.privateDialong .el-dialog__close {
  color: #fff !important;
  font-size: 20px;
}
.privateDialong .el-dialog__headerbtn {
  top: 12px;
}
.privateDialong .el-dialog__title {
  color: #fff !important;
}
.privateDialong .el-dialog__header {
  padding: 10px 20px;
  background-color: #409eff;
}
.privateDialong .el-dialog__body {
  padding: 20px 20px 10px;
}
.privateDialong .el-checkbox {
  color: #333;
  width: 100%;
  line-height: 30px;
  padding-left: 30px;
}
.privateDialong .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
.privateDialong .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #409eff;
}
.privateDialong .el-date-editor {
  height: 30px;
}
.privateDialong .el-input__inner,
.privateDialong .el-textarea__inner {
  border: 1px solid #adb1c3;
  height: 30px;
  line-height: 30px;
}
.privateDialong .el-dialog__footer {
  padding: 0 20px 30px;
}
.privateDialong .el-button {
  font-size: 14px !important;
  width: 64px;
  height: 30px;
  border-radius: 2px !important;
  padding: 0 !important;
}
.privateDialong .btn-que {
  background-color: #409eff !important;
  border-color: transparent !important;
}
.privateDialong .btn-del {
  background-color: #fff !important;
  color: #333 !important;
  border-color: #b8b8b8 !important;
}
</style>
